export default {
  MAX_API_RESULTS_LIMIT: 500 // corresponds to BaseAPIConstants.MAX_RESULTS_LIMIT
};